class CollectionFilter extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            collections: '.js-collection-filter-block',
            navToggle: '.js-collection-filter-nav-toggle',
            products: '.js-collection-filter-product',
            sortByToggle: '.js-collection-filter-sort-by-toggle',
            sortByTitle: '.js-collection-filter-sort-by-ttl',
            resultsCount: ".js-collection-filter-result-count",
            noProducts: '.js-collection-filter-no-products'
        }

        this.collections = this.querySelectorAll(this.selectors.collections);
        this.resultsCount = this.querySelectorAll(this.selectors.resultsCount);
        this.navToggle = this.querySelectorAll(this.selectors.navToggle);
        this.products = this.querySelectorAll(this.selectors.products);
        this.sortByToggle = this.querySelectorAll(this.selectors.sortByToggle);
        this.sortByTitle = this.querySelector(this.selectors.sortByTitle);
        this.noProducts = this.querySelector(this.selectors.noProducts);

        this.data = [];
        this.dataCollections = [];
        this.dataFilters = {sort: '', collection: 'all'};
        this.isLoading = false;
        this.initData();
        this.initNav();
        this.setResultsCount();
        this.checkParameter();
    }

    setResultsCount() {
        this.resultsCount.forEach(el => {
            el.textContent = this.querySelectorAll('.js-collection-filter-product:not(.is-hide)').length;
        })
    }


    checkParameter() {

        const urlParams = new URLSearchParams(window.location.search);
        const sortBy = urlParams.getAll('sort_by');
        const mainCollection = urlParams.getAll('main-collection');
        this.dataFilters = {
            sort: sortBy.length > 0 ? sortBy[0] : '',
            collection: mainCollection.length > 0 ? mainCollection[0] : 'all'
        };
        if (this.dataFilters.sort != '') {
            const el = this.querySelector(`${this.selectors.sortByToggle}[data-value="${this.dataFilters.sort}"]`);
            if (el != null) {
                this.sortEvent(el, false);
            }
        }
        if (this.dataFilters.collection != 'all') {
            const el = this.querySelector(`${this.selectors.navToggle}[data-collection="${this.dataFilters.collection}"]`);
            if (el != null) {
                this.navEvent(el, true)
            }
            const els = this.querySelectorAll(`.sr-collection-block`);
            els.forEach(item => {
                item.style.display = "none"
            })
        }
        this.classList.add('is-load')
    }


    setUrl() {
        let url = '?';
        if (this.dataFilters.collection !== 'all') {
            url += `${(url == '?') ? '' : '&'}main-collection=${this.dataFilters.collection}`;
        }
        if (this.dataFilters.sort != '') {
            url += `${(url == '?') ? '' : '&'}sort_by=${this.dataFilters.sort}`;
        }

        if (history.pushState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + url;
            window.history.pushState({path: newurl}, '', newurl);
        }
    }

    initData() {
        this.products.forEach((el) => {
            this.data.push({
                productId: el.getAttribute('data-product'),
                element: el,
            })
        });
        this.collections.forEach((collection) => {
            let data = [];
            collection.querySelectorAll(this.selectors.products).forEach((el) => {
                data.push({
                    element: el,
                    rate: parseFloat(el.getAttribute('data-rating')),
                    created: Number(new Date(el.getAttribute('data-created'))),
                    price: parseInt(el.getAttribute('data-price'), 10)
                })
            });
            this.dataCollections.push({
                collection: collection,
                products: data
            })
        });
    }

    sortProducts(sortValue) {
        this.dataCollections.forEach((colEl) => {
            let newProducts = [...colEl.products];
            console.log(sortValue, newProducts)
            switch (sortValue) {
                case 'created-descending':
                    newProducts.sort((a, b) => (b.created > a.created ? 1 : -1));
                    break;
                case 'created-ascending':
                    newProducts.sort((a, b) => (a.created > b.created ? 1 : -1));
                    break;
                case 'price-ascending':
                    newProducts.sort((a, b) => (a.price > b.price ? 1 : -1));
                    break;
                case 'price-descending':
                    newProducts.sort((a, b) => (b.price > a.price ? 1 : -1));
                    break;
                default:
            }
            let index = 0;
            newProducts.forEach((product,) => {
                if (!product.element.classList.contains('is-hide')) {
                    product.element.style.order = `${(index > 4) ? (index + 1) : index}`;
                    index += 1;
                }
            });

        })

    }

    toggleNoResult() {
        let hasProducts = false;
        this.collections.forEach(el => {
            if (el.classList.contains('is-active')) {
                if (el.querySelectorAll(`${this.selectors.products}:not(.is-hide)`).length > 0) {
                    hasProducts = true;
                }
            }
        });
        if (hasProducts) {
            this.noProducts.classList.remove('is-show')
        } else {
            this.noProducts.classList.add('is-show')
        }
    }

    navEvent(el, isSetUrl) {
        const dataCollection = el.getAttribute('data-collection');

        if (dataCollection !== 'all') {
            this.products.forEach(product => {
                if (product.getAttribute('data-collection').split(',').includes(dataCollection)) {
                    product.classList.remove('is-hide');
                } else {
                    product.classList.add('is-hide');
                }
            })
            const els = this.querySelectorAll(`.sr-collection-block`);
            els.forEach(item => {
                item.style.display = "none"
            })
        } else {
            this.products.forEach(product => {
                product.classList.remove('is-hide');
            });
            const els = this.querySelectorAll(`.sr-collection-block`);
            els.forEach(item => {
                item.style.display = "";
            })
        }
        this.navToggle.forEach(elToggle => {
            elToggle.classList.remove('is-active')
        });
        el.classList.add('is-active');
        this.dataFilters.collection = dataCollection;
        this.toggleNoResult();
        this.setResultsCount();
        if (isSetUrl) {
            this.setUrl();
        }
    }

    initNav() {

        this.navToggle.forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                this.navEvent(el, true)
            });
        });


        this.sortByToggle.forEach(el => {
            el.addEventListener('change', (e) => {
                e.preventDefault();
                console.log("change", el.value);

                // if (!el.classList.contains('is-active')) {
                this.sortEvent(el, true);
                // }
            });
        });

    }

    sortEvent(el, isSetUrl) {
        const sortValue = el.value;
        this.sortProducts(sortValue);
        this.sortByTitle.classList.remove('is-open')
        this.dataFilters.sort = sortValue;
        if (isSetUrl == true) {
            this.setUrl();
        }
        this.setResultsCount();
    }


    getValue(arr1, arr2) {
        const arr2Set = new Set(arr2);
        return arr1.some(el => arr2Set.has(el));
    }

    filterProducts(isSetUrl) {
        let tagsUrl = '';
        const activeTags = this.querySelectorAll('.js-collection-filter-toggle.is-selected');

        this.products.forEach((el) => {
            el.classList.add('is-hide');
            el.classList.add('is-fade');
        });
        let dataFilters = {filter1: [], filter2: [], filter3: []};

        this.filterLists.forEach((el) => {
            const activeFilters = el.querySelectorAll('.js-collection-filter-toggle.is-selected');
            let values = []
            let index = 0;
            if (activeFilters.length > 0) {
                activeFilters.forEach(filter => {
                    values.push(filter.getAttribute('data-filter'));
                    index = filter.getAttribute('data-index');
                });
            }

            const name = `filter${index}`;
            dataFilters[name] = values;
        })

        let filteredData = this.data;
        if (dataFilters.filter3.length > 0) {
            filteredData = filteredData.filter(el => this.getValue(dataFilters.filter3, el.filter3));
        }
        if (dataFilters.filter2.length > 0) {
            filteredData = filteredData.filter(el => this.getValue(dataFilters.filter2, el.filter2));
        }
        if (dataFilters.filter1.length > 0) {
            filteredData = filteredData.filter(el => this.getValue(dataFilters.filter1, el.filter1));
        }
        filteredData.forEach(el => {
            el.element.classList.remove('is-hide');
            setTimeout(() => {
                el.element.classList.remove('is-fade');
            }, 1);
        });
        this.collections.forEach(el => {
            if (el.querySelectorAll(`${this.selectors.products}:not(.is-hide)`).length > 0) {
                el.classList.add('has-products');
            } else {
                el.classList.remove('has-products')
            }
        });
        const sortValue = this.querySelector(`${this.selectors.sortByToggle}.is-active`).getAttribute('data-value');
        this.sortProducts(sortValue);
        this.dataFilters.filter1 = dataFilters.filter1;
        this.dataFilters.filter2 = dataFilters.filter2;
        this.dataFilters.filter3 = dataFilters.filter3;
        if (isSetUrl == true) {
            this.setUrl();
        } else {
            this.collectionsWrap.classList.add('is-show')
        }
        this.toggleNoResult();
        this.setResultsCount();
    }


    setSellingPlan(productId, rtxWidgetInjectionParent, addToCart, el) {
        const productData = JSON.parse(document.getElementById(rtxWidgetInjectionParent.getAttribute('data-product-json')).innerHTML);
        const form = rtxWidgetInjectionParent.closest('form');
        const currentVariant = parseInt(form.querySelector("[name='id']").value, 10);
        const variant = productData.variants.find(o => o.id === currentVariant);
        var selectedOption = rtxWidgetInjectionParent.querySelector(`input[name="selling_plan_select"]:checked`);

        if (selectedOption.value === 'onetime') {

            rtxWidgetInjectionParent.querySelector(`#selling_plan_${productId}`).value = '';

            rtxWidgetInjectionParent.querySelectorAll(`.rtx_option_plans`).forEach(plans => {
                plans.style.display = "none"
            })
        } else if (selectedOption.value === 'subsave') {
            if (variant.avaliable) {
                var planId = form.querySelector('.rtx_option_plans_label.active');
                if (planId.length > 0) {
                    var id = parseInt(planId.attr('data-id'), 10)
                    const curSelPlan = variant.selling_plan_allocations.find(o => o.selling_plan_id === id)

                    if (curSelPlan) {
                        document.querySelector(`#rtx_widget_injection_parent_${productId} .rtx_option--sub .rtx_option_subheading`).textContent = theme.Currency.formatMoney(curSelPlan.price, theme.moneyFormat)
                    }
                }
            }
            if (rtxWidgetInjectionParent.querySelector(`input[name="rtx_option_plans_dropdown"]:checked`) == null) {
                return false;
            }
            rtxWidgetInjectionParent.querySelector(`[name="selling_plan"]`).value = rtxWidgetInjectionParent.querySelector(`input[name="rtx_option_plans_dropdown"]:checked`).value
            rtxWidgetInjectionParent.querySelectorAll(`.rtx_option_plans`).forEach(plans => {
                plans.style.display = "grid"
            })
        }
    }

}

export default CollectionFilter;
